module.exports = "/_next/static/images/1864dab1ec5984e6869a326a95392b25-nucommunity-lg@3x.jpg.webp";